module.exports = __webpack_public_path__ + "img/header.fd3e6b65.png";